var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg354",
    xmlSpace: "preserve",
    width: 24.66669,
    height: 24.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs358"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath368"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path366"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g360",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g364",
    clipPath: "url(#clipPath368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g370",
    transform: "translate(497,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-133.101 -107.9,-241 -241,-241 -133.103,0 -241,107.899 -241,241 0,133.103 107.897,241 241,241 C -107.9,241 0,133.103 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path372"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g374",
    transform: "translate(352.4004,288.1338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-53.24 -43.158,-96.4 -96.4,-96.4 -53.244,0 -96.401,43.16 -96.401,96.4 0,53.239 43.157,96.399 96.401,96.399 C -43.158,96.399 0,53.239 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path376"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g378",
    transform: "translate(112.2129,62.5752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 7.71,72.602 69.142,129.158 143.787,129.158 74.647,0 136.078,-56.56 143.785,-129.16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path380"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/iconUser.3361bc9394d40aa665dda5eeea4740d5.svg";
export { ForwardRef as ReactComponent };